// extracted by mini-css-extract-plugin
export var borderRadius = "_bk-4";
export var large = "_bk-3";
export var logoContainer = "_bk-0";
export var nameLogo = "_bk-2";
export var small = "_bk-1";